import * as React from 'react';

import {RemoveButton} from '../button/remove-button/remove-button';

import styles from './attachment-count.module.css';

type Props = {
    fileName: string;
    onRemove: () => void;
};

export const SingleAttachment = ({fileName, onRemove}: Props) => (
    <div className={styles['single-file']}>
        <RemoveButton size={12} onClick={onRemove} />
        <div>{fileName}</div>
    </div>
);
